import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_COMMS_STACK_TEMPLATE_EXPERIMENTATION_ENABLED = createFcmDetails(
	'comms_stack_template_experimentation_enabled',
	{
		owner: 'Site Platform',
		context: 'comms stack',
		description: 'Global flag to enable template experimentation in emails.',
		import: false,
	},
);
